// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form___NFfS","wrap":"Login_wrap__3I2rF"};